import { render } from "./IsTyping.vue?vue&type=template&id=aac57ef0"
import script from "./IsTyping.vue?vue&type=script&lang=js"
export * from "./IsTyping.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__